import removeTags from '../removeTags'

export default (hit, size, userConnected) => {
  let templateType = 'pic'
  let ctaLabel = ''
  let tag = ''
  let date = new Date(hit.publicationDate.date)
  date = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`

  let picSizes = [[454, 244], [467, 251], [703, 377], [356, 191]]

  if (size === 'L') {
    picSizes = [[680, 260], [467, 251], [703, 377], [356, 191]]
  }

  switch (hit.type) {
    case 'study':
      ctaLabel = 'Lire l\'étude'
      tag = 'Étude'
      break
    case 'activity-report':
      ctaLabel = 'Voir le rapport d\'activité'
      tag = 'Rapport d\'activité'
      break
    case 'thematic-brochure':
      templateType = 'picto'
      ctaLabel = 'Voir la plaquette'
      tag = 'Plaquette thématique'
      break
    case 'practical-guide':
      templateType = 'picto'
      ctaLabel = 'Voir la note adhérent'
      tag = 'Note adhérent'
      break
    case 'btob-news':
      ctaLabel = 'Lire le BtoB news'
      tag = 'BtoB news'
      break
    case 'barometer-activity':
      ctaLabel = 'Découvrir le baromètre'
      tag = 'Baromètre d\'activité'
      break
  }

  const docHidden = hit.isMemberOnly && !userConnected

  return `
    <div class="card-common card-common--${size} card-publi card-publi--${hit.type} ${templateType === 'picto' ? 'card-publi--picto' : ''}">
      <a href="/${hit.path}" class="card-common__wrap">
          <div class="card-common__tags ${templateType === 'picto' ? 'card-common__tags--picto' : ''}">
              <span class="tag">${tag}</span>
              ${hit.isMemberOnly
                ? `<span class="tag tag--adherent">
                    <svg width="10" height="13" class="mr-1 icon--violet">
                        <use href="#icon-lock" xlink:href="#icon-lock"></use>
                    </svg>
                    Adhérent
                  </span>`
                : ''
              }
          </div>
          
          ${templateType === 'pic'
            ? `<picture class="card-common__pic ${size === 'L' ? 'card-common__pic--publi-L' : 'card-common__pic--publi'}">
                  <source media="(max-width:420px)" data-srcset="https://res.cloudinary.com/dw196z9vy/image/upload/c_fill,f_auto,q_auto,w_${picSizes[3][0]},h_${picSizes[3][1]}/${hit.image.singleMedia.publicId}">
                  <source media="(max-width:767px)" data-srcset="https://res.cloudinary.com/dw196z9vy/image/upload/c_fill,f_auto,q_auto,w_${picSizes[2][0]},h_${picSizes[2][1]}/${hit.image.singleMedia.publicId}">
                  <source width="${picSizes[1][0]}" height="${picSizes[1][1]}" media="(max-width:1023px)" data-srcset="https://res.cloudinary.com/dw196z9vy/image/upload/c_fill,f_auto,q_auto,w_${picSizes[1][0]},h_${picSizes[1][1]}/${hit.image.singleMedia.publicId}">
                  <img class="w-full lazyload" width="${picSizes[0][0]}" height="${picSizes[0][1]}" data-src="https://res.cloudinary.com/dw196z9vy/image/upload/c_fill,f_auto,q_auto,w_${picSizes[0][0]},h_${picSizes[0][1]}/${hit.image.singleMedia.publicId}" alt="${hit.image.singleMedia.alt}"/>
              </picture>`
            : `<div class="card-publi__picto ${hit.type === 'thematic-brochure' ? 'card-publi__picto--orange' : ''}">
                ${hit.type === 'thematic-brochure'
                  ? `<svg width="48" height="66" class="mt-8 ml-16">
                      <use href="#icon-publication-brochure" xlink:href="#icon-publication-brochure"></use>
                    </svg>`
                  : `<svg width="78" height="57" class="mt-9 ml-11">
                      <use href="#icon-publication-guide" xlink:href="#icon-publication-guide"></use>
                    </svg>`
                }
              </div>`
          }

          <div class="card-common__inner mt-5">
              <div>
                  <p class="card-common__date ${templateType === 'pic' ? 'text-grey-dark' : 'text-white'}">
                    <svg width="12" height="12" class="mr-2 ${hit.type === 'practical-guide' ? 'icon--white' : 'icon--violet'}">
                      <use href="#icon-hour" xlink:href="#icon-hour"></use>
                    </svg>
                    <span>Publié le <span class="font-bold ${templateType === 'pic' ? 'text-violet' : 'text-white'}">${date}</span></span>
                  </p>

                  <p class="title-card ${size === 'L' ? templateType === 'picto' ? 'title-card--XL' : 'title-card--L' : templateType === 'picto' ? 'title-card--L-pic' : ''} ${templateType === 'pic' ? 'text-violet' : 'text-white'} mb-3">${hit.title}</p>

                  ${hit.description !== null
                    ? `<div class="card-publi__chapo ${templateType === 'pic' ? 'text-grey-dark' : 'text-white'}">
                        ${removeTags(hit.description)}
                      </div>`
                    : ''
                  }
              </div>

              <span class="cta-arrow ${hit.type === 'thematic-brochure' ? 'cta-arrow--circle-violet' : ''} ${templateType === 'pic' ? 'text-violet' : 'text-white'} mt-5">
                ${ctaLabel}

                <span class="cta-arrow__circle">
                  <svg width="8" height="8" class="icon--white">
                    <use href="#icon-arrow" xlink:href="#icon-arrow"></use>
                  </svg>
                </span>
              </span>
          </div>
      </a>
      
      ${hit.document.singleMedia.publicId !== null && !docHidden
        ? `<a href="https://res.cloudinary.com/dw196z9vy/image/upload/${hit.document.singleMedia.publicId}" target="_blank" rel="nofollow"
            class="card-common__action ${hit.type === 'thematic-brochure' ? 'card-common__action--violet' : ''} icon-center">
            <svg width="20" height="20" class="icon--white">
              <use href="#icon-download" xlink:href="#icon-download"></use>
            </svg>
            <span class="sr-only">Télécharger le document</span>
          </a>`
        : ''
      }
  </div>
  `
}
